import env from './env';

export type AppStages = 'development' | 'staging' | 'production';

interface AppConfig {
  stage: AppStages;
  sentry: {isEnable: boolean; dsn: string};
  api: {
    host: string;
    url: string;
    timeout: number;
    version: string;
  };
  appointmentApi: {
    host: string;
    url: string;
    timeout: number;
    version: string;
  };
  googleClientId: string;
  googleMapURL: string;
  googleAnalytics: {
    isEnable: boolean;
    measurementId?: string; // main GA
    mdqMeasurementId?: string; // mdq GA
  };
  [key: string]: any;
}

const {STAGE} = env as {STAGE: AppStages};
const config: AppConfig = {
  stage: STAGE,
  sentry: {isEnable: env.SENTRY_ENABLED, dsn: env.SENTRY_DSN},
  api: {
    host: env.API.HOST,
    url: `${env.API.HOST}`,
    timeout: env.API.TIMEOUT,
    version: '1.8.0',
  },
  appointmentApi: {
    host: env.APPOINTMENT_API.HOST,
    url: `${env.APPOINTMENT_API.HOST}`,
    timeout: env.APPOINTMENT_API.TIMEOUT,
    version: '1.8.0',
  },
  storeUrl: {
    android: 'https://play.google.com/store/apps/details?id=com.easeapp',
    ios: 'https://apps.apple.com/app/ease-birth-control-telehealth/id1583695430',
  },
  googleClientId: env.GOOGLE_CLIENT_ID,
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${env.GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
  googleAnalytics: {
    isEnable: env.GOOGLE_ANALYTICS_ENABLED,
    measurementId: env.GOOGLE_ANALYTICS_MEASUREMENT_ID,
    mdqMeasurementId: env.GOOGLE_ANALYTICS_MDQ_MEASUREMENT_ID,
  },
};

if (STAGE === 'staging') {
}
if (STAGE === 'production') {
}

export default config;
